// userInput/escapeKey.js — Escape as a "close / back" key for a container that has no own keyboard handling. Ignored
// while the user types in a field (input, textarea, select, contenteditable) and while an IME composes.
// Second resident of the userInput package (plan bugfix_2026-10-08_polishing-patch). Consumer: the frontend document
// detail window (index.js). The backend documents popup keeps its own Escape logic for now (todo userinput-module-plan).

export function isTypingTarget(el) {
    return !!el && (el.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName));
}

// Calls handler(ev) on Escape. Returns release(). Listens to keydown in the CAPTURE phase: the handler sees the page
// before any other Escape handler reacts — e.g. the gallery closes itself on keydown; a later handler would no longer
// see that it was open (User 2026-10-08). Held-down repeats are ignored.
export function onEscape(handler, { target = document } = {}) {
    const onKeyDown = (ev) => {
        if (ev.key !== 'Escape' || ev.repeat || ev.isComposing || isTypingTarget(ev.target)) { return; }
        handler(ev);
    };
    target.addEventListener('keydown', onKeyDown, true);
    return () => target.removeEventListener('keydown', onKeyDown, true);
}
